// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"116":"f2684da0","125":"73676f84","134":"525cce39","256":"0aa41532","334":"edea66c7","478":"5122a2a1","484":"7c0462b4","546":"b39eb719","725":"3ebd4885","786":"2de27443","801":"14f07cc5","910":"5eaefbea"}[chunkId] + ".chunk.js";
};